const {BI_ERROR_ENDPOINT, BI_SOURCE, workerLoggerFactory} = require('dbsm-common/src/bi/bi.js')
const {getAppUrl} = require('dbsm-common/src/worker/getUrl')
const getAppVersion = require('dbsm-common/src/getAppVersion')
const webBiLogger = require('web-bi-logger').default

const APP_NAME = 'dbsm-viewer-app'

module.exports = () => {
  const factory = webBiLogger
    .factory({endpoint: BI_ERROR_ENDPOINT})
    .updateDefaults({
      src: BI_SOURCE,
      ver: getAppVersion(getAppUrl(APP_NAME)),
      app_name: APP_NAME,
      evid: 10 // error event ID
    })

  return workerLoggerFactory(factory)
}



// WEBPACK FOOTER //
// ./viewer-app-module/setupBiLogger.js